import { render } from "./FunilProdutos.vue?vue&type=template&id=144f49ea&scoped=true"
import script from "./FunilProdutos.vue?vue&type=script&lang=js"
export * from "./FunilProdutos.vue?vue&type=script&lang=js"

import "./FunilProdutos.vue?vue&type=style&index=0&id=144f49ea&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-144f49ea"]])

export default __exports__